import React from "react";
import { Gauge } from "lucide-react";
import { computeScore, SCORE_TONE } from "../lib/score";
import { Badge } from "./ui/badge";

export default function Scorecard({ plan }) {
  const s = computeScore(plan);
  const tone = SCORE_TONE[s.tone];
  const R = 34;
  const C = 2 * Math.PI * R;
  const offset = C - (s.score / 100) * C;

  return (
    <div data-testid="plan-scorecard" className="rounded-2xl border border-slate-800 bg-slate-900/60 p-5 flex flex-col sm:flex-row items-center gap-6">
      <div className="relative shrink-0" style={{ width: 96, height: 96 }}>
        <svg width="96" height="96" className="-rotate-90">
          <circle cx="48" cy="48" r={R} stroke="currentColor" strokeWidth="8" fill="none" className="text-slate-800" />
          <circle
            cx="48" cy="48" r={R} strokeWidth="8" fill="none" strokeLinecap="round"
            stroke="currentColor" className={tone.ring}
            strokeDasharray={C} strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 0.7s cubic-bezier(0.22,1,0.36,1)" }}
          />
        </svg>
        <div className="absolute inset-0 grid place-items-center">
          <span data-testid="scorecard-value" className={`font-display text-2xl font-extrabold ${tone.text}`}>{s.score}</span>
        </div>
      </div>

      <div className="flex-1 w-full">
        <div className="flex items-center gap-2">
          <Gauge className="h-4 w-4 text-slate-400" />
          <span className="text-sm text-slate-400">Readiness score</span>
          <Badge data-testid="scorecard-grade" className={`${tone.badge} ml-auto`}>{s.grade}</Badge>
        </div>
        <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mt-3">
          {s.breakdown.map((b) => (
            <div key={b.label}>
              <div className="flex justify-between text-xs text-slate-400 mb-1"><span>{b.label}</span><span>{b.points}/{b.max}</span></div>
              <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden">
                <div className={`h-full rounded-full ${tone.ring.replace("text-", "bg-")}`} style={{ width: `${(b.points / b.max) * 100}%`, transition: "width 0.6s ease" }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
